import React, { useRef, useState, useEffect } from 'react';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import mb_reupload from '../../../../images/icons/mb_upload.svg';
import pdf_solid from '../../../../images/icons/pdf.svg';

export const GetImgComp = ({ imgUrl, setEdit }) => {
  return (
    <div className="relative w-44 h-28 ">
      <div
        id="img"
        onClick={e => {
          if (imgUrl) {
            window.open(imgUrl, '_blank');
          }
        }}
        className="w-44 h-28 bg-white my-2 relative mx-auto "
      >
        {imgUrl ? (
          <img
            className="block"
            src={imgUrl}
            alt="image"
            className="w-40 h-28"
            onError={e => {
              e.target.onerror = null;
              e.target.src = pdf_solid;
            }}

          />
          
        ) : (
          <CircularLoading />
        )}
      </div>
      <div
        onClick={() => setEdit(true)}
        className="absolute z-50 top-0 right-0 -mt-3 -mr-4  "
      >
        <img className="h-12 w-12" src={mb_reupload} alt="re-upload" />
      </div>
    </div>
  );
};
